/**
 * delivery hub hooks
 */
const Hook = () => {
    // order by date delivered
    const orderByDateDelivered = (a, b) => {
        if (!a.dateDelivered) {
            return 1;
        }
        if (!b.dateDelivered) {
            return -1;
        }
        return new Date(b.dateDelivered) - new Date(a.dateDelivered);
    };

    // always order customs first
    const orderCustomsFlagFirst = a => {
        if (a.customsPaymentDateDue) {
            return -1;
        }
        return 1;
    };

    // sort aplhanumerically by Tracking number
    const sortAlphabetically = (a, b) => {
        if (a.trackingNumber < b.trackingNumber) {
            return -1;
        }
        if (a.trackingNumber > b.trackingNumber) {
            return 1;
        }
        return 0;
    };

    // order based on status
    const orderByStatus = list => {
        const statusBucket = statusCode => {
            return list.filter(item => {
                return item.lastTrackingEventCategoryId === statusCode;
            });
        };

        // separating out to order the items

        const customs = statusBucket("1")
            .sort(sortAlphabetically)
            .sort(orderCustomsFlagFirst);
        const transit = statusBucket("0").sort(sortAlphabetically);
        const sorting = statusBucket("3").sort(sortAlphabetically);
        const received = statusBucket("2").sort(sortAlphabetically);
        const delivered = statusBucket("4").sort(orderByDateDelivered);
        const notDelivered = statusBucket("5").sort(sortAlphabetically);
        const returnToSender = statusBucket("6").sort(sortAlphabetically);

        return [...customs, ...transit, ...sorting, ...received, ...delivered, ...notDelivered, ...returnToSender];
    };

    // compare a date in the past to a date supplied to this function
    const checkDateInThePast = (date, days) => {
        // get two days ago from today
        const daysInPast = new Date();
        const compareDate = new Date(date);

        // find the days in the passed based on the days param
        daysInPast.setDate(daysInPast.getDate() - days);

        // compare the selectedDate
        if (compareDate > daysInPast) {
            return true;
        }
        return false;
    };

    // function to filter for recently delivered items
    const evaluateForRecentlyDelivered = item => {
        if (item.returnType === "RECEIVER") {
            // APMD-44:  4, 5 and 6 are to be displayed in the inbound items tab in some cases
            if (["4", "5", "6"].indexOf(item.lastTrackingEventCategoryId) > -1) {
                // until the <delivery date> is greater than 2 calendar days previous to 'today'
                if (!checkDateInThePast(item.dateDelivered, 2)) {
                    return true;
                }
            }
        }
        return false;
    };

    const evaluateForInboundItems = item => {
        // the return type needs to be a sender
        if (item.returnType === "RECEIVER") {
            // APMD-44: if the item is In Transit, Customs, Received or Sorting: display it as inbound ()
            if (["0", "1", "2", "3"].indexOf(item.lastTrackingEventCategoryId) > -1) {
                return true;
            }
            // APMD-44:  4, 5 and 6 are to be displayed in the inbound items tab in some cases
            if (["4", "5", "6"].indexOf(item.lastTrackingEventCategoryId) > -1) {
                // while the <delivery date> is greater than 2 calendar days previous to 'today'
                if (checkDateInThePast(item.dateDelivered, 2)) {
                    return true;
                }
            }
        }
        return false;
    };

    const evaluateCustomsInboundData = item => {
        // the return type needs to be a sender
        if (item.returnType === "RECEIVER") {
            if (item.customsPaymentRequired) {
                return true;
            }
        }
        return false;
    };

    const filterInboundItems = trackingItems => {
        const inboundItems = trackingItems.filter(item => {
            return evaluateForInboundItems(item);
        });

        return orderByStatus(inboundItems);
    };

    const filterSentItems = trackingItems => {
        const sentItems = trackingItems.filter(item => {
            return item.returnType === "SENDER";
        });

        return orderByStatus(sentItems);
    };

    const filterRecentlyDelivered = trackingItems => {
        const recentlyDelivered = trackingItems.filter(item => {
            return evaluateForRecentlyDelivered(item);
        });

        return orderByStatus(recentlyDelivered);
    };

    const filterCustomsData = trackingItems => {
        return trackingItems.filter(item => {
            return evaluateCustomsInboundData(item);
        });
    };

    const getDeliveryStatusInfo = status => {
        switch (status) {
            case "0":
                return {
                    labelText: "In transit",
                    statusClass: "#FF9C00"
                };
            case "1":
                return {
                    labelText: "Customs",
                    statusClass: "#D22630"
                };
            case "2":
                return {
                    labelText: "Item received",
                    statusClass: "#217BBE"
                };
            case "3":
                return {
                    labelText: "Sorting",
                    statusClass: "#FF9C00"
                };
            case "4":
                return {
                    labelText: "Delivered",
                    statusClass: "#00A76A"
                };
            case "5":
                return {
                    labelText: "Delivery attempted",
                    statusClass: "#D22630"
                };
            case "6":
                return {
                    labelText: "Return to sender",
                    statusClass: "#217BBE"
                };
            case "7":
                return {
                    labelText: "Info received",
                    statusClass: "#217BBE"
                };
            default:
                return {
                    labelText: "",
                    statusClass: ""
                };
        }
    };

    const getManageDeliveriesDropdownOptions = (indexMapping, res) => {
      const newMappedResults = [];
                      
      for (let i = 0; i < res.length; i++) {
        let charIndex = i + 1;
        if (indexMapping[charIndex]) {
            let currentChar = res[i];
            if (currentChar === 'Y') {
                newMappedResults.push(indexMapping[charIndex]);
            }
        }
      }

      return newMappedResults;
    }

    return {
        orderByDateDelivered,
        filterInboundItems,
        filterSentItems,
        filterRecentlyDelivered,
        getDeliveryStatusInfo,
        filterCustomsData,
        getManageDeliveriesDropdownOptions
    };
};

export default Hook;
